// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__7Xr5c","content":"GlobalSearch_content__255In"};